import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const salesApi = {
  // Admin
  adminAll: (businessDate) =>
    axiosClient
      .get(ENDPOINTS.adminSales.list, {
        params: businessDate ? { businessDate } : {},
      })
      .then(unwrap),

  adminDetail: (saleId) =>
    axiosClient.get(`/api/pos/sales/admin/${saleId}`).then(unwrap),

  adminCorrectionBites: (saleId) =>
    axiosClient
      .get(`/api/pos/sales/admin/${saleId}/correction-bites`)
      .then(unwrap),

  adminManualCorrection: (saleId, data) =>
    axiosClient
      .put(ENDPOINTS.adminSales.manualCorrection(saleId), data)
      .then(unwrap),

  // POS / cashier
  posBottles: () => axiosClient.get(ENDPOINTS.pos.bottles).then(unwrap),

  posBites: () => axiosClient.get(ENDPOINTS.pos.bites).then(unwrap),

  create: (data) =>
    axiosClient.post(ENDPOINTS.pos.createSale, data).then(unwrap),

  getById: (saleId) =>
    axiosClient.get(ENDPOINTS.pos.saleDetail(saleId)).then(unwrap),

  mySales: (cashierId, businessDate) => {
    const params = {};

    if (cashierId) {
      params.cashierId = cashierId;
    }

    if (businessDate) {
      params.businessDate = businessDate;
    }

    return axiosClient.get(ENDPOINTS.pos.mySales, { params }).then(unwrap);
  },

  requestCorrection: (saleId, data) =>
    axiosClient.post(ENDPOINTS.pos.correctionRequest(saleId), data).then(unwrap),

  adminCashiersForMissedSale: () =>
    axiosClient.get("/api/pos/sales/admin/cashiers").then(unwrap),

  adminMissedSaleBites: (cashierId) =>
    axiosClient
      .get(`/api/pos/sales/admin/missed/cashiers/${cashierId}/bites`)
      .then(unwrap),

  adminCreateMissedSale: (data) =>
    axiosClient.post("/api/pos/sales/admin/missed", data).then(unwrap),

  mySalesPage: async ({
    page = 0,
    size = 10,
    fromDate = "",
    toDate = "",
  } = {}) => {
    const params = new URLSearchParams();

    params.append("page", String(page));
    params.append("size", String(size));

    if (fromDate) {
      params.append("fromDate", fromDate);
    }

    if (toDate) {
      params.append("toDate", toDate);
    }

    const response = await axiosClient.get(
      `${ENDPOINTS.pos.mySalesPage}?${params.toString()}`
    );

    return response.data.data;
  },
};

export const cashSessionApi = {
  getCurrent: (cashierId) =>
    axiosClient
      .get(ENDPOINTS.pos.cashCurrent, { params: { cashierId } })
      .then(unwrap),

  open: (data) => axiosClient.post(ENDPOINTS.pos.cashOpen, data).then(unwrap),

  close: (data) => axiosClient.post(ENDPOINTS.pos.cashClose, data).then(unwrap),

  adminAll: (businessDate, outletCode) => {
    const params = {};
    if (businessDate) params.businessDate = businessDate;
    if (outletCode && outletCode !== "ALL") params.outletCode = outletCode;
    return axiosClient
      .get(ENDPOINTS.cashSessions.list, { params })
      .then(unwrap);
  },
};

export const correctionApi = {
  getAll: () => axiosClient.get(ENDPOINTS.corrections.list).then(unwrap),

  approve: (id, data) =>
    axiosClient.post(ENDPOINTS.corrections.approve(id), data).then(unwrap),

  reject: (id, data) =>
    axiosClient.post(ENDPOINTS.corrections.reject(id), data).then(unwrap),
};
